import * as Yup from "yup";

// const emailRegex = new RegExp(
//   "^" +
//     "([A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*)" +
//     "@" +
//     "((?!-)[A-Za-z0-9-]{1,63}(?<!-)\\." +
//     "(?!-)(?:[A-Za-z0-9-]{1,63}(?<!-)\\.)*" +
//     "[A-Za-z]{2,})" +
//   "$"
// );

// export const emailSchema = Yup.string()
//     .required("Field is required")
//     .max(254, "Email must be at most 254 characters long")
//     .test("is-valid-email", "Email not valid", (value) => {
//         if (!value) return false;
//         const match = value.match(emailRegex);
//         if (!match) return false;

//         const localPart = match[1];
//         const domainPart = match[2];

//         if (localPart.length > 64 || domainPart.length > 190) return false;

//         const domainParts = domainPart.split(".");
//         const tld = domainParts[domainParts.length - 1];
//         if (!tld || tld.length < 2) return false;

//         return true;
//     });

const localPartRegex = /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*$/;
const domainRegex = /^(?!-)[A-Za-z0-9-]{1,63}(?<!-)(?:\.(?!-)[A-Za-z0-9-]{1,63}(?<!-))*\.[A-Za-z]{2,}$/;

export const emailSchema = Yup.string()
    .required("Field is required")
    .max(254, "Email must be at most 254 characters long")
    .test("no-invalid-chars", "Email must not contain spaces or invalid characters", (value) => {
        if (!value) return false;
        return !/\s/.test(value);
    })
    .test("valid-format", "Email must contain local and domain parts", (value) => {
        if (!value || !value.includes("@")) return false;
        const [local, domain] = value.split("@");
        return !!local && !!domain;
    })
    .test("has-at-symbol", "Email must contain @ symbol", (value) => {
        if (!value) return false;
        return value.includes("@");
    })
    .test("valid-local", "Local part of the email is invalid", (value) => {
        if (!value || !value.includes("@")) return true;
        const [local] = value.split("@");
        return local !== undefined && localPartRegex.test(local);
    })
    .test("valid-domain", "Domain part of the email is invalid", (value) => {
        if (!value || !value.includes("@")) return true;
        const [, domain] = value.split("@");
        return domain !== undefined && domainRegex.test(domain);
    })
    .test("local-length", "Local part must not exceed 64 characters", (value) => {
        if (!value || !value.includes("@")) return true;
        const [local] = value.split("@");
        return local !== undefined && local.length <= 64;
    })
    .test("domain-length", "Domain part must not exceed 190 characters", (value) => {
        if (!value || !value.includes("@")) return true;
        const [, domain] = value.split("@");
        return domain !== undefined && domain.length <= 190;
    })
    .test("tld-check", "Top-level domain must be at least 2 characters long", (value: any) => {
        if (!value || !value.includes("@")) return true;
        const [, domain] = value.split("@");
        if (!domain) return true;
        const domainParts = domain.split(".");
        const tld = domainParts[domainParts.length - 1];
        return tld && tld.length >= 2;
    });

export const passwordSchema = Yup.string()
    .required("Field is required")
    .min(8, "Password must be at least 8 characters long")
    .max(128, "Password must not exceed 128 characters")
    .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
    .matches(/[a-z]/, "Password must contain at least one lowercase letter")
    .matches(/\d/, "Password must contain at least one number")
    .matches(/[!@#$%^&*()\-=+{}[\];:'"<>,.?/|\\~]/, "Password must contain at least one special character")
    .test("no-spaces", "Password must not contain spaces", (val) => !val || !/\s/.test(val))
    .test("no-4-repeats", "Password must not contain more than three repeating characters in a row", (val) => !val || !/(.)\1\1\1/.test(val))
    .matches(/^[A-Za-z\d!@#$%^&*()\-=+{}\[\];:'"<>,.?/|\\~]*$/, "Password must contain only English letters and allowed symbols");

export const getPasswordSchema = (intl: any) =>
    Yup.string()
        .required(intl({id: "FieldIsRequired"}))
        .min(8, intl({id: "password.min"}))
        .max(128, intl({id: "password.max"}))
        .matches(/[A-Z]/, intl({id: "password.uppercase"}))
        .matches(/[a-z]/, intl({id: "password.lowercase"}))
        .matches(/\d/, intl({id: "password.number"}))
        .matches(/[!@#$%^&*()\-=+{}[\];:'"<>,.?/|\\~]/, intl({id: "password.special"}))
        .test("no-spaces", intl({id: "password.spaces"}), (val) => !val || !/\s/.test(val))
        .test("no-4-repeats", intl({id: "password.repeats"}), (val) => !val || !/(.)\1\1\1/.test(val))
        .matches(/^[A-Za-z\d!@#$%^&*()\-=+{}\[\];:'"<>,.?/|\\~]*$/, intl({id: "password.english"}));

export const getEmailSchema = (intl: any) =>
  Yup.string()
    .required(intl({ id: "FieldIsRequired" }))
    .max(254, intl({ id: "email.max" }))
    .test(
      "no-invalid-chars",
      intl({ id: "email.noInvalidChars" }),
      (value) => {
        if (!value) return false;
        return !/\s/.test(value);
      }
    )
    .test(
      "valid-format",
      intl({ id: "email.validFormat" }),
      (value) => {
        if (!value || !value.includes("@")) return false;
        const [local, domain] = value.split("@");
        return !!local && !!domain;
      }
    )
    .test(
      "has-at-symbol",
      intl({ id: "email.hasAtSymbol" }),
      (value) => {
        if (!value) return false;
        return value.includes("@");
      }
    )
    .test(
      "valid-local",
      intl({ id: "email.validLocal" }),
      (value) => {
        if (!value || !value.includes("@")) return true;
        const [local] = value.split("@");
        return local !== undefined && localPartRegex.test(local);
      }
    )
    .test(
      "valid-domain",
      intl({ id: "email.validDomain" }),
      (value) => {
        if (!value || !value.includes("@")) return true;
        const [, domain] = value.split("@");
        return domain !== undefined && domainRegex.test(domain);
      }
    )
    .test(
      "local-length",
      intl({ id: "email.localLength" }),
      (value) => {
        if (!value || !value.includes("@")) return true;
        const [local] = value.split("@");
        return local !== undefined && local.length <= 64;
      }
    )
    .test(
      "domain-length",
      intl({ id: "email.domainLength" }),
      (value) => {
        if (!value || !value.includes("@")) return true;
        const [, domain] = value.split("@");
        return domain !== undefined && domain.length <= 190;
      }
    )
    .test(
      "tld-check",
      intl({ id: "email.tldCheck" }),
      // @ts-ignore
      (value) => {
        if (!value || !value.includes("@")) return true;
        const [, domain] = value.split("@");
        if (!domain) return true;
        const domainParts = domain.split(".");
        const tld = domainParts[domainParts.length - 1];
        return tld && tld.length >= 2;
      }
    );
